// extracted by mini-css-extract-plugin
export default {"profileCardBox":"ProfileCard_profileCardBox__K82jf","textBox":"ProfileCard_textBox__g6Os7"};